import { COSMETIC_HUES, type HueShift } from '../../assets/asset-store';
import type { Product } from '../../game/constants/products';
import type { ProfileShip } from '../../account/profile-ship';

export interface WornSkin {
  readonly imagePath: string;
  readonly shift: HueShift | null;
}

export interface ProfileLayers {
  readonly skin: WornSkin | null;
  readonly decal: WornSkin | null;
}

/** Resolved as `Renderer.drawWorn` does, so a portrait and the ship it becomes cannot disagree. */
export function wornSkin(
  products: readonly Product[],
  productId: number,
  team: number,
): WornSkin | null {
  return worn(products, productId, team, 'skin');
}

/** Trail and tag are captured in the arrangement and deliberately not resolved here. */
export function profileLayers(
  products: readonly Product[],
  profile: ProfileShip | null,
  team: number,
): ProfileLayers {
  if (profile === null) return { skin: null, decal: null };
  return {
    skin: worn(products, profile.skinProductId, team, 'skin'),
    decal: worn(products, profile.decalProductId, team, 'decal'),
  };
}

function worn(
  products: readonly Product[],
  productId: number,
  team: number,
  kind: 'decal' | 'skin',
): WornSkin | null {
  if (productId <= 0) return null;
  const product = products.find((entry) => entry.id === productId);
  if (product === undefined || product.imagePath === '' || product.tab !== kind) return null;
  return {
    imagePath: product.imagePath,
    shift: product.hued ? (COSMETIC_HUES[kind][team] ?? null) : null,
  };
}
